import { useState } from "react";
import { apply } from "../../../../core/utils";
import { displayError, displayMessage } from "../../../../core/utils/modals";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import { useRouting } from "../../../../hooks/with-routing";
import { enviarCodigo as apiEnviarCodigo, obtenerIniciales as apiObtenerIniciales, registrarCuenta as apiRegistrarCuenta } from "../api/common.api";
import RegistrarUsuarioForm from "../components/registrar-usuario.form";

export enum RegistrarUsuarioSteps {
	Inicio,
	Captura,
	Registro
}

const useRegistrarUsuario = () => {
	const segmento = useRouting.use.currentSegment();
	const [cargandoDatos, setCargandoDatos] = useState(false);
	const [iniciales, setIniciales] = useState("");
	const [currentStep, setCurrentStep] = useState(RegistrarUsuarioSteps.Inicio);
	const navigate = usePathNavigate();

	const reiniciar = () => {
		setIniciales("");
		setCurrentStep(RegistrarUsuarioSteps.Inicio);
	};

	const obtenerIniciales = (usuario: string) => {
		setCargandoDatos(true);

		apiObtenerIniciales(segmento, usuario)
			.then(setIniciales)
			.then(apply(setCurrentStep, RegistrarUsuarioSteps.Captura))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const enviarCodigo = (usuario: string, telefono: string) => {
		setCargandoDatos(true);

		apiEnviarCodigo(segmento, usuario, telefono)
			.then(apply(setCurrentStep, RegistrarUsuarioSteps.Registro))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const registrarCuenta = (usuario: string, clave: string, codigoOtp: string) => {
		setCargandoDatos(true);

		apiRegistrarCuenta(segmento, usuario, clave, codigoOtp)
			.then(apply(displayMessage, "La cuenta del usuario fue registrada con éxito"))
			.then(apply(navigate, "/:segmento/login"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const reenviarCodigo = (usuario: string, telefono: string) => {
		setCargandoDatos(true);

		apiEnviarCodigo(segmento, usuario, telefono)
			.then(apply(displayMessage, "Hemos enviado tu nuevo token al teléfono que registraste"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	return {
		currentStep,
		cargandoDatos,
		iniciales,
		obtenerIniciales,
		enviarCodigo,
		reenviarCodigo,
		registrarCuenta,
		reiniciar
	};
};

const RegistrarUsuarioPage = () => {
	const {
		currentStep,
		cargandoDatos,
		iniciales,
		obtenerIniciales,
		enviarCodigo,
		reenviarCodigo,
		registrarCuenta,
		reiniciar
	} = useRegistrarUsuario();

	return (
		<div className="vh-100 d-flex justify-content-center align-items-center">
			<div className="container">
				<div className="row d-flex justify-content-center">
					<div className="col-12 col-md-8 col-lg-5">
						<div className="card card-login">
							<div className="card-body p-5">
								<RegistrarUsuarioForm
									cargandoDatos={cargandoDatos}
									step={currentStep}
									iniciales={iniciales}
									obtenerIniciales={obtenerIniciales}
									enviarCodigo={enviarCodigo}
									reenviarCodigo={reenviarCodigo}
									registrarCuenta={registrarCuenta}
									reiniciar={reiniciar}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegistrarUsuarioPage;